import React from "react";
import Calendar from 'react-calendar';

function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const SingleCustomCalendarPicker = ({
  value = null,
  onChange = () => {},
  calendarStartDate = new Date(),
  setCalendarStartDate = () => {},
  maxDate = new Date(),
  selectRange = false,
  selectedDate = value,
}) => {
  return (
    <Calendar
      value={value}
      onChange={onChange}
      activeStartDate={calendarStartDate}
      onActiveStartDateChange={({ activeStartDate }) => setCalendarStartDate(activeStartDate)}
      showFixedNumberOfWeeks={true}
      next2Label={null}
      prev2Label={null}
      prevLabel=""
      nextLabel=""
      selectRange={selectRange}
      // maxDate={new Date()}
      navigationLabel={({ date, label }) => (<span style={{ fontWeight: 'bold' }}>{label}</span>)}
      formatShortWeekday={(locale, date) => {
        const shortWeekday = date.toLocaleDateString(locale, { weekday: "short" });
        return capitalizeFirstLetter(shortWeekday);
      }}
      tileContent={({ date, view }) => {
        if (view !== 'month') return null;

        const dateStr = date.toDateString();
        const selectedStr = selectedDate?.toDateString();
        const isSelected = selectedStr === dateStr;
        const isToday = dateStr === new Date().toDateString();
        const isCurrentMonth = date.getMonth() === calendarStartDate.getMonth() && date.getFullYear() === calendarStartDate.getFullYear();

        const backgroundColor = isSelected ? '#00C4B5' : isToday ? '#F94545' : 'transparent';
        const borderRadius = isToday && !isSelected ? '50%' : '4px';
        const color = isSelected || isToday ? '#FFFFFF' : isCurrentMonth ? '#282A2C' : '#B6B9BB';

        return (
          <div style={{ display: 'grid', gridTemplateColumns: '4.5px 1fr 4.5px', height: '100%', width: '100%', boxSizing: 'border-box', position: 'relative' }}>
            <div />
            <div style={{ backgroundColor: 'transparent', borderRadius: '4px', position: 'relative', height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', boxSizing: 'border-box', zIndex: 1 }}>
              <div
                style={{ backgroundColor, borderRadius, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 600, color, height: '32px', width: '32px', transition: 'background-color 0.2s ease' }}
                className={`${isToday ? 'no-hoverin-bg' : ''} tile ${isToday || isSelected ? 'no-hover-bg' : ''}`}
              >
                {date.getDate()}
              </div>
            </div>
            <div />
          </div>
        );
      }}
    />
  );
};

export default SingleCustomCalendarPicker;
